
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { Theme } from '@mui/material';

interface IProps {
  disableShadow?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {},
  showHasMoreContent: {
    boxShadow: theme.customProperties.Shadows.topShadow,
    zIndex: 1,
  },
});

const DialogScrollOverlay: React.FC<
  React.PropsWithChildren<IProps>
> = props => (
  <div
    className={classNames(props.classes.container, {
      [props.classes.showHasMoreContent]: !props.disableShadow,
    })}
  >
    {props.children}
  </div>
);

export default withStyles(DialogScrollOverlay, styles);
